import useFeatureFlag from '../useFeatureFlag';

export function useV2JoinMeeting() {
  return useFeatureFlag('APP3481_V2_Join_Meeting', false);
}
